const intCasinoInitialState = {
    spribe: [],
    vivo: [],
    sagaming: [],
    ezugi: [],
    evolution: [],
};

export default intCasinoInitialState;
